import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import AthleteSearchPanel from "../../common/athletes/AthleteSearchPanel";
import AthleteScore from "../../../components/athlete-scores/athlete-score";
import { useResponsiveHeight } from "../../../hooks/useResponsiveHeight";

function AdminAthlete() {
  const authUser = useAuthUser();
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [isAthleteSelected, setIsAthleteSelected] = useState(false);

  const { adjustedHeight } = useResponsiveHeight({
    mobileOffset: 295,
    tabletOffset: 230,
    desktopOffset: 230,
  });

  const athleteSelected = (athlete) => {
    setSelectedAthlete(athlete);
    setIsAthleteSelected(true);
  };

  return (
    <div className="p-0 xl:p-4 h-screen lg:h-full xl:h-full bg-gray-100">
      <div className="flex flex-col xl:flex-row lg:flex-row gap-4 h-full">
        <div className="w-full lg:w-2/5 xl:w-2/5">
          <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300 h-screen lg:h-full xl:h-full overflow-y-auto">
            <h1 className="text-xl mb-3 uppercase">Athletes</h1>
            <AthleteSearchPanel
              authUser={authUser}
              selectedAthlete={selectedAthlete}
              onAthleteSelected={athleteSelected}
              adjustedHeight={adjustedHeight}
              showFilters
            />
          </div>
        </div>

        {isAthleteSelected ? (
          <div className="w-full lg:w-3/5 xl:w-3/5">
            <div className="athletes-list h-full event_details_mob md:absolute xl:relative lg:relative md:col-span-7 xl:col-span-7 xl:space-y-0 xl:bg-transparent xl:border-gray-300 p-0 md:space-y-0 md:top-0 xl:top-0 lg:top-0">
              <div className="text-blue-600 pt-6 px-6 md:visible xl:hidden lg:hidden sm:visible">
                <NavLink onClick={() => setIsAthleteSelected(false)}>
                  <FontAwesomeIcon icon={faChevronLeft} /> Back
                </NavLink>
              </div>
              {selectedAthlete ? (
                <AthleteScore
                  userId={selectedAthlete.userId}
                  showOffers
                  showTrackittScore
                  showPositionScore
                  searchEvent={false}
                  showProfile
                  showRank
                  showLikes
                />
              ) : null}
            </div>
          </div>
        ) : (
          <div className="w-full lg:w-3/5 xl:w-3/5 flex items-center justify-center min-h-[60vh]">
            <div className="w-full p-2 flex flex-col items-center justify-center">
              <div className="hidden md:block lg:block text-center">
                <img
                  alt="Athlete Name"
                  src="/select_row.svg"
                  className="object-cover h-20 pb-3 mx-auto"
                />
                <p className="text-center text-[#8E8E93] text-1xl">
                  Please select an Athlete to view their Profile
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminAthlete;
